// import axios from "axios";
// import React, { useEffect, useState } from "react";

// const CreateGroup = () => {
  

//   const [waId, setWaId] = useState(null);
//   const [pid, setPid] = useState(null);

  
  
//     // 1️⃣ FETCH USER DATA (RUNS ONCE)
//     useEffect(() => {
//       const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//       if (!loggedUser) return;
  
//       // ROLE-BASED EMAIL
//       const emailToUse =
//         loggedUser.role === "admin"
//           ? loggedUser.email
//           : loggedUser.adminEmail;
  
//       console.log("API Email Used:", emailToUse);
//       if (!emailToUse) return;
  
//       axios
//         .get(
//           `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//             emailToUse
//           )}`
//         )
//         .then((response) => {
//           const userData = response.data;
//           console.log("this is userData1", userData);
  
//           if (userData.wa_id) {
//             setWaId(userData.wa_id);
//             setPid(userData.p_id)
//           }
//         })
//         .catch((err) => {
//           console.error("Error retrieving user data:", err);
//         });
//     }, []); // 👈 FIXED — run once only
  


//   return (
//     <div>
//     {waId} this is waid
//     {pid} this is pid 
//     </div>
//   );
// }

// export default CreateGroup;


// import axios from "axios";
// import React, { useEffect, useState } from "react";

// const CreateGroup = () => {
//   const [waId, setWaId] = useState(null);
//   const [pid, setPid] = useState(null);

//   const [subject, setSubject] = useState("");
//   const [description, setDescription] = useState("");

//   // 1️⃣ FETCH USER DATA (RUNS ONCE)
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse =
//       loggedUser.role === "admin"
//         ? loggedUser.email
//         : loggedUser.adminEmail;

//     if (!emailToUse) return;

//     axios
//       .get(
//         `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//           emailToUse
//         )}`
//       )
//       .then((response) => {
//         const userData = response.data;

//         if (userData.wa_id) {
//           setWaId(userData.wa_id);
//           setPid(userData.p_id);
//         }
//       })
//       .catch((err) => {
//         console.error("Error retrieving user data:", err);
//       });
//   }, []);

//   // 2️⃣ CREATE GROUP API CALL
//   const handleCreateGroup = async () => {
//     if (!pid) return alert("PID not loaded yet!");
//     if (!subject.trim()) return alert("Subject required");
//     if (!description.trim()) return alert("Description required");

//     try {
//       const response = await axios.post(
//         "https://emedha.com/echatbot/enotifier/groups/cgroup.php",
//         {
//           pid: pid,
//           subject: subject,
//           description: description,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       console.log("Create Group Response:", response.data);
//       alert("Group created successfully ✔️");

//       // Reset fields
//       setSubject("");
//       setDescription("");
//     } catch (error) {
//       console.error("Error creating group:", error);
//       alert("Failed to create group ❌");
//     }
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>Create Group</h2>

//       <p><strong>WA ID:</strong> {waId}</p>
//       <p><strong>PID:</strong> {pid}</p>

//       <div style={{ marginTop: "20px" }}>
//         <label>Subject:</label><br />
//         <input
//           type="text"
//           value={subject}
//           onChange={(e) => setSubject(e.target.value)}
//           placeholder="Enter subject"
//           style={{ width: "300px", padding: "8px" }}
//         />
//       </div>

//       <div style={{ marginTop: "15px" }}>
//         <label>Description:</label><br />
//         <textarea
//           value={description}
//           onChange={(e) => setDescription(e.target.value)}
//           placeholder="Enter description"
//           style={{ width: "300px", height: "80px", padding: "8px" }}
//         />
//       </div>

//       <button
//         onClick={handleCreateGroup}
//         style={{
//           marginTop: "20px",
//           padding: "10px 20px",
//           background: "blue",
//           color: "white",
//           border: "none",
//           cursor: "pointer",
//         }}
//       >
//         Create Group
//       </button>
//     </div>
//   );
// };

// export default CreateGroup;



// import axios from "axios";
// import React, { useEffect, useState } from "react";

// const CreateGroup = () => {
//   const [waId, setWaId] = useState(null);
//   const [pid, setPid] = useState(null);

//   const [subject, setSubject] = useState("");
//   const [description, setDescription] = useState("");

//   const [groups, setGroups] = useState([]);
//   const [after, setAfter] = useState("");
//   const [before, setBefore] = useState("");

//   const limit = 10;

//   // ---------------------------------------------------
//   // 1️⃣ FETCH USER DATA (wa_id, p_id)
//   // ---------------------------------------------------
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse =
//       loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;

//     axios
//       .get(
//         `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//           emailToUse
//         )}`
//       )
//       .then((response) => {
//         const userData = response.data;
//         if (userData.wa_id) {
//           setWaId(userData.wa_id);
//           setPid(userData.p_id);
//         }
//       })
//       .catch((err) => console.error("Error retrieving user data:", err));
//   }, []);

//   // ---------------------------------------------------
//   // 2️⃣ CREATE GROUP API (cgroup.php)
//   // ---------------------------------------------------
//   const createGroup = async () => {
//     if (!subject || !description)
//       return alert("Subject & Description are required!");

//     try {
//       const res = await axios.post(
//         "https://emedha.com/echatbot/enotifier/groups/cgroup.php",
//         {
//           pid,
//           subject,
//           description,
//         },
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       console.log("Group Created:", res.data);
//       alert("Group created successfully!");

//       setSubject("");
//       setDescription("");

//       fetchGroups(); // refresh group list
//     } catch (err) {
//       console.error("Error creating group:", err);
//       alert("Failed to create group!");
//     }
//   };

//   // ---------------------------------------------------
//   // 3️⃣ GET ALL GROUPS WITH PAGINATION (getAllGroups.php)
//   // ---------------------------------------------------
//   const fetchGroups = async (direction = "") => {
//     try {
//       const body = {
//         pid,
//         limit,
//         after: direction === "next" ? after : "",
//         before: direction === "prev" ? before : "",
//       };

//       const res = await axios.post(
//         "https://emedha.com/echatbot/enotifier/groups/getAllGroups.php",
//         body,
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       );
//       console.log('this is res',res)

//       const data = res.data?.data || [];
// console.log('this is data',data)
//       setGroups(data);

//       if (data.length > 0) {
//         setAfter(data[data.length - 1].id); // last id
//         setBefore(data[0].id); // first id
//       }
//     } catch (err) {
//       console.error("Error fetching groups:", err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>Create Group</h2>

//       <p><b>WID:</b> {waId}</p>
//       <p><b>PID:</b> {pid}</p>

//       <input
//         type="text"
//         placeholder="Enter Subject"
//         value={subject}
//         onChange={(e) => setSubject(e.target.value)}
//         style={{ width: "300px", padding: "8px", marginBottom: "10px" }}
//       />
//       <br />

//       <textarea
//         placeholder="Enter Description"
//         value={description}
//         onChange={(e) => setDescription(e.target.value)}
//         style={{ width: "300px", height: "80px", padding: "8px" }}
//       />
//       <br />

//       <button onClick={createGroup} style={{ marginTop: "10px" }}>
//         Create Group
//       </button>

//       <hr />

//       <h2>Active Groups</h2>

//       <button onClick={() => fetchGroups()} style={{ marginBottom: "10px" }}>
//         Load Groups
//       </button>

//       <ul>
//         {groups.map((g) => (
//           <li key={g.id}>
//             <b>{g.subject}</b> — {g.description}
//           </li>
//         ))}
//       </ul>

//       {groups.length > 0 && (
//         <div style={{ marginTop: "15px" }}>
//           <button onClick={() => fetchGroups("prev")}>⬅ Previous</button>
//           <button onClick={() => fetchGroups("next")} style={{ marginLeft: "10px" }}>
//             Next ➡
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CreateGroup;


// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { MdDelete, MdGroups } from "react-icons/md";
// import { FaPlusCircle } from "react-icons/fa";

// const CreateGroup = () => {
//   const [waId, setWaId] = useState(null);
//   const [pid, setPid] = useState(null);

//   const [subject, setSubject] = useState("");
//   const [description, setDescription] = useState("");

//   const [groups, setGroups] = useState([]);
//   const [after, setAfter] = useState("");
//   const [before, setBefore] = useState("");

//   const limit = 20;

//   // ------------------------------
//   // 1️⃣ Fetch WA_ID & P_ID
//   // ------------------------------
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse =
//       loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//           emailToUse
//         )}`
//       )
//       .then((res) => {
//         const data = res.data;
//         setWaId(data.wa_id);
//         setPid(data.p_id);
//       })
//       .catch((err) => console.error("User data error:", err));
//   }, []);

//   // ------------------------------
//   // 2️⃣ Auto Load Groups on PID ready
//   // ------------------------------
//   useEffect(() => {
//     if (pid) fetchGroups();
//   }, [pid]);

//   // ------------------------------
//   // 3️⃣ Create Group
//   // ------------------------------
//   const createGroup = async () => {
//     if (!subject || !description) return alert("Subject & Description required");

//     try {
//       await axios.post("https://emedha.com/echatbot/enotifier/groups/cgroup.php",
//         { pid, subject, description },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       alert("Group Created Successfully!");
//       setSubject("");
//       setDescription("");
//       fetchGroups();
//     } catch (err) {
//       console.error("Create group error:", err);
//       alert("Failed to create group");
//     }
//   };

//   // ------------------------------
//   // 4️⃣ Fetch All Groups
//   // ------------------------------
//   const fetchGroups = async (direction = "") => {
//     if (!pid) return;

//     try {
//       const body = {
//         pid,
//         limit,
//         after: direction === "next" ? after : "",
//         before: direction === "prev" ? before : "",
//       };

//       const res = await axios.post(
//         "https://emedha.com/echatbot/enotifier/groups/getAllGroups.php",
//         body,
//         { headers: { "Content-Type": "application/json" } }
//       );

//       const data = res.data?.data || [];
//       setGroups(data);

//       if (data.length > 0) {
//         setAfter(data[data.length - 1].id);
//         setBefore(data[0].id);
//       }
//     } catch (err) {
//       console.error("Fetch groups error:", err);
//     }
//   };

//   // ------------------------------
//   // 5️⃣ DELETE GROUP
//   // ------------------------------
//   const deleteGroup = async (groupId) => {
//     if (!window.confirm("Are you sure to delete this group?")) return;

//     try {
//       await axios.post(
//         "https://emedha.com/echatbot/enotifier/groups/deleteGroup.php",
//         { groupId },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       alert("Group Deleted!");
//       fetchGroups();
//     } catch (err) {
//       console.error("Delete group error:", err);
//       alert("Failed to delete group");
//     }
//   };

//   return (
//     <div
//       style={{
//         padding: "25px",
//         maxWidth: "900px",
//         margin: "auto",
//         fontFamily: "Poppins",
//       }}
//     >
//       {/* TITLE */}
//       <h2
//         style={{
//           fontSize: "28px",
//           fontWeight: "600",
//           marginBottom: "20px",
//           color: "#0158a2",
//         }}
//       >
//         Create New Group
//       </h2>

//       {/* USER DETAILS */}
//       <div
//         style={{
//           background: "#eaf4ff",
//           padding: "15px",
//           borderRadius: "10px",
//           marginBottom: "20px",
//         }}
//       >
//         <p>
//           <b>WhatsApp ID:</b> {waId}
//         </p>
//         <p>
//           <b>PID:</b> {pid}
//         </p>
//       </div>

//       {/* FORM CARD */}
//       <div
//         style={{
//           background: "white",
//           padding: "20px",
//           borderRadius: "12px",
//           boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
//           marginBottom: "35px",
//         }}
//       >
//         <h3 style={{ marginBottom: "15px", color: "#333" }}>Enter Group Details</h3>

//         <input
//           type="text"
//           placeholder="Enter Group Subject"
//           value={subject}
//           onChange={(e) => setSubject(e.target.value)}
//           style={{
//             width: "100%",
//             padding: "12px",
//             borderRadius: "8px",
//             border: "1px solid #ccc",
//             marginBottom: "12px",
//           }}
//         />

//         <textarea
//           placeholder="Enter Description"
//           value={description}
//           onChange={(e) => setDescription(e.target.value)}
//           style={{
//             width: "100%",
//             height: "90px",
//             padding: "12px",
//             borderRadius: "8px",
//             border: "1px solid #ccc",
//           }}
//         />

//         <button
//           onClick={createGroup}
//           style={{
//             marginTop: "15px",
//             padding: "12px 18px",
//             background: "#0158a2",
//             color: "white",
//             borderRadius: "8px",
//             border: "none",
//             cursor: "pointer",
//             fontSize: "16px",
//             display: "flex",
//             alignItems: "center",
//             gap: "8px",
//           }}
//         >
//           <FaPlusCircle size={20} /> Create Group
//         </button>
//       </div>

//       {/* GROUP LIST */}
//       <h2 style={{ marginBottom: "15px" }}>All Groups</h2>

//       <div>
//         {groups.map((g) => (
//           <div
//             key={g.id}
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               background: "#fff",
//               padding: "15px",
//               borderRadius: "10px",
//               boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
//               marginBottom: "12px",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
//               <MdGroups size={32} color="#0158a2" />
//               <div>
//                 <h4 style={{ margin: 0 }}>{g.subject}</h4>
//                 <p style={{ margin: "5px 0 0 0", color: "#666" }}>
//                   {g.description}
//                 </p>
//               </div>
//             </div>

//             {/* DELETE BUTTON */}
//             <MdDelete
//               size={28}
//               color="red"
//               style={{ cursor: "pointer" }}
//               onClick={() => deleteGroup(g.groupId)}
//             />
//           </div>
//         ))}
//       </div>

//       {/* PAGINATION */}
//       {groups.length > 0 && (
//         <div style={{ marginTop: "20px", textAlign: "center" }}>
//           <button
//             onClick={() => fetchGroups("prev")}
//             style={{
//               padding: "10px 15px",
//               borderRadius: "8px",
//               border: "1px solid #ccc",
//               cursor: "pointer",
//               marginRight: "10px",
//             }}
//           >
//             ⬅ Previous
//           </button>
//           <button
//             onClick={() => fetchGroups("next")}
//             style={{
//               padding: "10px 15px",
//               borderRadius: "8px",
//               border: "1px solid #ccc",
//               cursor: "pointer",
//             }}
//           >
//             Next ➡
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CreateGroup;


// import React from "react";
// import { UsersRound, Search, Trash2, ChevronLeft, ChevronRight } from "lucide-react";

// const contacts = [
//   { name: "Varahi Jewels", id: "1" },
//   { name: "Emedha Emp Group", id: "2" },
// ];

// export default function CreateGroup() {
//   return (
//     // PageWrapper replacement
//     <div style={{ padding: "24px", fontFamily: "sans-serif", backgroundColor: "#f9fafb", minHeight: "100vh" }}>
      
//       {/* Header section */}
//       <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "32px", height: "32px", backgroundColor: "#e0e7ff", borderRadius: "6px", color: "#4f46e5" }}>
//           <UsersRound size={17} />
//         </div>
//         <div>
//           <h1 style={{ fontSize: "20px", fontWeight: "600", margin: 0, color: "#111827" }}>Create New Group</h1>
//           <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginTop: "4px", fontSize: "12px", color: "#6b7280" }}>
//             <p style={{ margin: 0 }}>WhatsApp ID: 107745195504024</p>
//             <p style={{ margin: 0 }}>PID: 112296891711407</p>
//           </div>
//         </div>
//       </div>

//       {/* FormCard 1: Enter Group Details */}
//       <div style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "1px solid #e5e7eb", padding: "20px", marginBottom: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//         <h2 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "16px", color: "#111827" }}>Enter Group Details</h2>
//         <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          
//           {/* Field: Group Name */}
//           <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//             <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151" }}>
//               Group Name <span style={{ color: "#ef4444" }}>*</span>
//             </label>
//             <input 
//               type="text" 
//               placeholder="Enter Group Name" 
//               required
//               style={{ padding: "8px 12px", fontSize: "14px", borderRadius: "6px", border: "1px solid #d1d5db", outline: "none" }}
//             />
//           </div>

//           {/* Field: Description */}
//           <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//             <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151" }}>Description</label>
//             <textarea 
//               placeholder="Enter group description or purpose..." 
//               style={{ padding: "8px 12px", fontSize: "14px", borderRadius: "6px", border: "1px solid #d1d5db", outline: "none", minHeight: "80px", resize: "vertical" }}
//             />
//           </div>

//         </div>
//       </div>

//       {/* FormCard 2: Create Group / Members Selection */}
//       <div style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "1px solid #e5e7eb", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//         <h2 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "16px", color: "#111827" }}>Create Group</h2>
        
//         {/* Search Bar */}
//         <div style={{ position: "relative", marginBottom: "16px" }}>
//           <Search size={14} style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }} />
//           <input
//             type="text"
//             placeholder="Search groups or members..."
//             style={{ width: "100%", padding: "8px 12px 8px 36px", fontSize: "14px", borderRadius: "8px", border: "1px solid #e5e7eb", backgroundColor: "#f9fafb", color: "#111827", boxSizing: "border-box", outline: "none" }}
//           />
//         </div>

//         {/* Contacts Table */}
//         <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: "8px", marginBottom: "16px" }}>
//           <table style={{ width: "100%", textAlign: "left", borderCollapse: "collapse" }}>
//             <thead>
//               <tr style={{ backgroundColor: "#f9fafb", borderBottom: "1px solid #e5e7eb", fontSize: "12px", fontWeight: "600", color: "#6b7280" }}>
//                 <th style={{ padding: "12px", width: "48px", textAlign: "center" }}>Select</th>
//                 <th style={{ padding: "12px", width: "48px" }}>Avatar</th>
//                 <th style={{ padding: "12px" }}>Name</th>
//                 <th style={{ padding: "12px", width: "64px", textAlign: "center" }}>Actions</th>
//               </tr>
//             </thead>
//             <tbody style={{ fontSize: "12px", color: "#374151" }}>
//               {contacts.map(({ name, id }) => (
//                 <tr key={id} style={{ borderBottom: "1px solid #e5e7eb" }}>
//                   <td style={{ padding: "12px", textAlign: "center" }}>
//                     <input type="checkbox" style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: "#4f46e5" }} />
//                   </td>
//                   <td style={{ padding: "12px" }}>
//                     <div style={{ width: "28px", height: "28px", borderRadius: "50%", backgroundColor: "#e0e7ff", display: "flex", alignItems: "center", justifyCenter: "center", justifyContent: "center", color: "#4f46e5", fontWeight: "bold" }}>
//                       {name[0]}
//                     </div>
//                   </td>
//                   <td style={{ padding: "12px", fontWeight: "500", color: "#111827" }}>{name}</td>
//                   <td style={{ padding: "12px", textAlign: "center" }}>
//                     <button style={{ color: "#6b7280", border: "none", backgroundColor: "transparent", padding: "4px", borderRadius: "4px", cursor: "pointer" }}>
//                       <Trash2 size={15} style={{ display: "block" }} />
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination Layout */}
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "between", justifyContent: "space-between", borderBottom: "1px solid #e5e7eb", paddingBottom: "16px", fontSize: "12px", color: "#6b7280" }}>
//           <span>Showing 1 to 2 of 2 entries</span>
//           <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//             <button style={{ padding: "6px", borderRadius: "4px", border: "1px solid #e5e7eb", backgroundColor: "#ffffff", opacity: 0.5, cursor: "not-allowed" }} disabled>
//               <ChevronLeft size={14} style={{ display: "block" }} />
//             </button>
//             <button style={{ padding: "4px 10px", borderRadius: "4px", border: "1px solid #4f46e5", backgroundColor: "rgba(79, 70, 229, 0.1)", color: "#4f46e5", fontWeight: "500", cursor: "pointer" }}>1</button>
//             <button style={{ padding: "6px", borderRadius: "4px", border: "1px solid #e5e7eb", backgroundColor: "#ffffff", opacity: 0.5, cursor: "not-allowed" }} disabled>
//               <ChevronRight size={14} style={{ display: "block" }} />
//             </button>
//           </div>
//         </div>
        
//         {/* Navigation Buttons */}
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
//           {/* SecondaryBtn replacement */}
//           <button style={{ padding: "8px 16px", fontSize: "14px", borderRadius: "6px", border: "1px solid #d1d5db", backgroundColor: "#ffffff", color: "#374151", fontWeight: "500", cursor: "pointer" }}>
//             All Groups
//           </button>
//           <div style={{ display: "flex", gap: "8px" }}>
//             {/* SecondaryBtn replacement */}
//             <button style={{ padding: "8px 16px", fontSize: "14px", borderRadius: "6px", border: "1px solid #d1d5db", backgroundColor: "#ffffff", color: "#374151", fontWeight: "500", cursor: "pointer" }}>
//               ⬅ Previous
//             </button>
//             {/* PrimaryBtn replacement */}
//             <button style={{ padding: "8px 16px", fontSize: "14px", borderRadius: "6px", border: "none", backgroundColor: "#4f46e5", color: "#ffffff", fontWeight: "500", cursor: "pointer" }}>
//               Next ➡
//             </button>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }



import axios from "axios";
import React, { useEffect, useState } from "react";
import { MdDelete, MdGroups } from "react-icons/md";
import { FaPlusCircle } from "react-icons/fa";
import { ChevronLeft, ChevronRight } from "lucide-react";

const CreateGroup = () => {
  const [waId, setWaId] = useState(null);
  const [pid, setPid] = useState(null);

  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");

  const [groups, setGroups] = useState([]);
  const [after, setAfter] = useState("");
  const [before, setBefore] = useState("");

  const limit = 20;

  // ------------------------------
  // 1️⃣ Fetch WA_ID & P_ID
  // ------------------------------
  useEffect(() => {
    const loggedUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loggedUser) return;

    const emailToUse =
      loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;

    axios
      .get(
        `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
          emailToUse
        )}`
      )
      .then((res) => {
        const data = res.data;
        setWaId(data.wa_id);
        setPid(data.p_id);
      })
      .catch((err) => console.error("User data error:", err));
  }, []);

  // ------------------------------
  // 2️⃣ Auto Load Groups on PID ready
  // ------------------------------
  useEffect(() => {
    if (pid) fetchGroups();
  }, [pid]);

  // ------------------------------
  // 3️⃣ Create Group
  // ------------------------------
  const createGroup = async () => {
    if (!subject || !description) return alert("Subject & Description required");

    try {
      await axios.post(
        "https://emedha.com/echatbot/enotifier/groups/cgroup.php",
        { pid, subject, description },
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Group Created Successfully!");
      setSubject("");
      setDescription("");
      fetchGroups();
    } catch (err) {
      console.error("Create group error:", err);
      alert("Failed to create group");
    }
  };

  // ------------------------------
  // 4️⃣ Fetch All Groups
  // ------------------------------
  const fetchGroups = async (direction = "") => {
    if (!pid) return;

    try {
      const body = {
        pid,
        limit,
        after: direction === "next" ? after : "",
        before: direction === "prev" ? before : "",
      };

      const res = await axios.post(
        "https://emedha.com/echatbot/enotifier/groups/getAllGroups.php",
        body,
        { headers: { "Content-Type": "application/json" } }
      );

      const data = res.data?.data || [];
      setGroups(data);

      if (data.length > 0) {
        setAfter(data[data.length - 1].id);
        setBefore(data[0].id);
      }
    } catch (err) {
      console.error("Fetch groups error:", err);
    }
  };

  // ------------------------------
  // 5️⃣ DELETE GROUP
  // ------------------------------
  const deleteGroup = async (groupId) => {
    if (!window.confirm("Are you sure to delete this group?")) return;

    try {
      await axios.post(
        "https://emedha.com/echatbot/enotifier/groups/deleteGroup.php",
        { groupId },
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Group Deleted!");
      fetchGroups();
    } catch (err) {
      console.error("Delete group error:", err);
      alert("Failed to delete group");
    }
  };

  return (
    <div style={{fontFamily: "sans-serif", backgroundColor: "#f9fafb", minHeight: "100vh" }}>
      
      {/* Header section */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "32px", height: "32px", backgroundColor: "#e0e7ff", borderRadius: "6px", color: "#4f46e5" }}>
          <MdGroups size={20} />
        </div>
        <div>
          <h1 style={{ fontSize: "20px", fontWeight: "600", margin: 0, color: "#111827" }}>Create New Group</h1>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginTop: "4px", fontSize: "12px", color: "#6b7280" }}>
            <p style={{ margin: 0 }}>WhatsApp ID: {waId || "Loading..."}</p>
            <p style={{ margin: 0 }}>PID: {pid || "Loading..."}</p>
          </div>
        </div>
      </div>

      {/* FormCard 1: Enter Group Details */}
      <div style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "1px solid #e5e7eb", padding: "20px", marginBottom: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
        <h2 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "16px", color: "#111827" }}>Enter Group Details</h2>
        
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {/* Field: Group Name */}
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151" }}>
              Group Name <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <input 
              type="text" 
              placeholder="Enter Group Subject" 
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
              style={{ padding: "8px 12px", fontSize: "14px", borderRadius: "6px", border: "1px solid #d1d5db", outline: "none", boxSizing: "border-box", width: "100%" }}
            />
          </div>

          {/* Field: Description */}
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151" }}>Description</label>
            <textarea 
              placeholder="Enter Description" 
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={{ padding: "8px 12px", fontSize: "14px", borderRadius: "6px", border: "1px solid #d1d5db", outline: "none", minHeight: "90px", resize: "vertical", boxSizing: "border-box", width: "100%" }}
            />
          </div>

          {/* Create Button layout */}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              onClick={createGroup}
              style={{ padding: "8px 16px", fontSize: "14px", borderRadius: "6px", border: "none", backgroundColor: "#4f46e5", color: "#ffffff", fontWeight: "500", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}
            >
              <FaPlusCircle size={16} /> Create Group
            </button>
          </div>
        </div>
      </div>

      {/* FormCard 2: Dynamic Groups View */}
      <div style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "1px solid #e5e7eb", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
        <h2 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "16px", color: "#111827" }}>All Groups</h2>

        {/* Contacts Table style container mapped to active dynamic items */}
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: "8px", marginBottom: "16px" }}>
          <table style={{ width: "100%", textAlign: "left", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#f9fafb", borderBottom: "1px solid #e5e7eb", fontSize: "12px", fontWeight: "600", color: "#6b7280" }}>
                <th style={{ padding: "12px", width: "48px" }}>Avatar</th>
                <th style={{ padding: "12px" }}>Subject / Name</th>
                <th style={{ padding: "12px" }}>Description</th>
                <th style={{ padding: "12px", width: "64px", textAlign: "center" }}>Actions</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: "12px", color: "#374151" }}>
              {groups.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ padding: "24px", textAlign: "center", color: "#6b7280" }}>
                    No groups found.
                  </td>
                </tr>
              ) : (
                groups.map((g) => (
                  <tr key={g.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                    <td style={{ padding: "12px" }}>
                      <div style={{ width: "28px", height: "28px", borderRadius: "50%", backgroundColor: "#e0e7ff", display: "flex", alignItems: "center", justifyContent: "center", color: "#4f46e5", fontWeight: "bold" }}>
                        {g.subject ? g.subject[0].toUpperCase() : "G"}
                      </div>
                    </td>
                    <td style={{ padding: "12px", fontWeight: "500", color: "#111827" }}>{g.subject}</td>
                    <td style={{ padding: "12px", color: "#6b7280" }}>{g.description}</td>
                    <td style={{ padding: "12px", textAlign: "center" }}>
                      <button 
                        onClick={() => deleteGroup(g.groupId)}
                        style={{ color: "#ef4444", border: "none", backgroundColor: "transparent", padding: "4px", borderRadius: "4px", cursor: "pointer" }}
                      >
                        <MdDelete size={18} style={{ display: "block", margin: "auto" }} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Dynamic Pagination Control block styling matches clean layout layout */}
        {groups.length > 0 && (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingTop: "4px", fontSize: "12px", color: "#6b7280" }}>
            <span>Showing active window entries</span>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <button 
                onClick={() => fetchGroups("prev")}
                style={{ display: "flex", alignItems: "center", gap: "4px", padding: "6px 12px", borderRadius: "4px", border: "1px solid #d1d5db", backgroundColor: "#ffffff", color: "#374151", fontWeight: "500", cursor: "pointer" }}
              >
                <ChevronLeft size={14} /> Previous
              </button>
              <button 
                onClick={() => fetchGroups("next")}
                style={{ display: "flex", alignItems: "center", gap: "4px", padding: "6px 12px", borderRadius: "4px", border: "1px solid #d1d5db", backgroundColor: "#ffffff", color: "#374151", fontWeight: "500", cursor: "pointer" }}
              >
                Next <ChevronRight size={14} />
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default CreateGroup;